<template>
  <section>
    <div
      v-for="n in count"
      :key="n"
      :class="['nr-loading', { 'nr-loading-animated': animated }]"
    ></div>
  </section>
</template>
<script>
export default {
  name: 'NrLoadingAnimation',
  props: {
    animated: {
      type: Boolean,
      default: true
    },
    count: {
      type: Number,
      default: 1
    }
  }
}
</script>
<style lang="scss">
@import '../../styles/tokens/tokens.scss';

@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

.nr-loading {
  height: 16px;
  margin: $spacing-8;
  &-animated {
    background-size: 400% 100%;
    animation-iteration-count: infinite;
    animation-name: skeleton-loading;
    animation-duration: 1.5s;
  }
  border-radius: $border-radius-default;
  background: linear-gradient(
    90deg,
    #dbdbdb 25%,
    rgba(219, 219, 219, 0.5) 50%,
    #dbdbdb 75%
  );
  &::after {
    content: ' ';
  }
}
</style>
